import { QueryConstraint, Unsubscribe } from "firebase/firestore";
import StoreComplement from "../entities/stores/complement";
import FirestorePipe from "../utils/pipe";
import EstablishmentDB from "./establishment";
import StoreDB from "./store";

class StoreComplementDB extends FirestorePipe {

  public static readonly colName = 'Complements'

  constructor(idEstab: string, idStore: string) {
    if(!idEstab)
      throw new Error('Informe o id do estabelecimento')
    super(`${EstablishmentDB.colName}/${idEstab}/${StoreDB.colName}/${idStore}/${StoreComplementDB.colName}`);
  }

  public define(id: string, data: StoreComplement): Promise<any> {
    return this._define(id, data);
  }
  public create(data: StoreComplement): Promise<any> {
    return this._create(data);
  }
  public update(id: string, data: StoreComplement): Promise<any> {
    return this._update(id, data);
  }
  public delete(id: string): Promise<any> {
    return this._delete(id);
  }
  public getAll(...params: QueryConstraint[]): Promise<StoreComplement[]> {
    return this._getAll<StoreComplement>(...params);
  }
  public get(id: string): Promise<StoreComplement> {
    return this._get(id);
  }
  public on(listener: (data: StoreComplement[]) => void, ...params: QueryConstraint[]): Unsubscribe {
    return this._on(listener, ...params);
  }

}

export default StoreComplementDB;